exports.Binding = require('./zstd-codec-binding.js')();
